import { type PromocodeGroupImportResult as SchemaPromocodeGroupImportResult } from '../schemas/PromocodeGroupImportResult';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Создает новые промокоды в группе, игнорируя дубликаты
 * @tags PromocodeGroups
 * @summary Добавление набора промокодов через excel
 */
export const PromocodeGroupPromocodesImportContentType = 'multipart/form-data' as const;
export type PromocodeGroupPromocodesImportRequest = {
    /**
     * @format binary
     */
    file: string;
};
export type PromocodeGroupPromocodesImportResponses = {
    /**
     * @description Результат импорта
     */
    '200': {
        'application/json': SchemaPromocodeGroupImportResult;
    };
};
export type PromocodeGroupPromocodesImportResponseSuccess =
    PromocodeGroupPromocodesImportResponses['200']['application/json'];
export type PromocodeGroupPromocodesImportSearchParams = {
    do_import: boolean;
};
export type PromocodeGroupPromocodesImportPathParameters = {
    group_id: string;
};
export const PromocodeGroupPromocodesImportUrl = '/promocode_groups/{group_id}/promocodes/import' as const;
export const PromocodeGroupPromocodesImportMethod = 'POST' as const;
export const getPromocodeGroupPromocodesImportUrl = (params: PromocodeGroupPromocodesImportPathParameters) =>
    PromocodeGroupPromocodesImportUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof PromocodeGroupPromocodesImportPathParameters) => String(params[param])
    );
